<div class="container-fluid animated fadeIn">
	<div class="row mt-5 mb-5">
		<!-- TITLES AND BUTTONS AREA -->
		<div class="col-xl-12">
			<div class="d-flex align-items-baseline justify-content-between top-area">
				<!-- Page title -->
				<div class="title-area d-flex flex-wrap align-items-baseline justify-content-between w-100 column-gap-3 row-gap-1">
					<h2 class="mb-0">{{ 'private-home.pageTitle' | translate }}</h2>
					<!-- link new features-->
					@if (newFeature) {
						<span class="new-feature">
							<a
								class="new-feature__link"
								target="_self"
								[href]="newFeature.url"
								[attr.download]="newFeature.fileName">
								{{ newFeature.label }}
							</a>
							@if (newFeature.date) {
								<span class="new-feature__date">· {{ newFeature.date }}</span>
							}
						</span>
					}
				</div>
			</div>
		</div>

		<!-- CONTENT -->
		<div class="col-xl-12 mt-2">
			@if (loggedUser?.IsSupplier && !loggedUser?.IsBuyer && !loggedUser?.IsFinancier) {
				<app-dashboard-supplier></app-dashboard-supplier>
			}
			@if (!loggedUser?.IsSupplier && loggedUser?.IsBuyer && !loggedUser?.IsFinancier) {
				<app-dashboard-buyer></app-dashboard-buyer>
			}
			@if (!loggedUser?.IsSupplier && !loggedUser?.IsBuyer && loggedUser?.IsFinancier) {
				<app-dashboard-financier></app-dashboard-financier>
			}
			@if (loggedUser?.IsSystemAdmin || loggedUser?.IsSupportOperator || loggedUser?.IsBackOfficeOperator) {
				<app-dashboard-operator> </app-dashboard-operator>
			}
		</div>
	</div>
</div>
